import { ReactNode } from 'react'

import { useAuth } from './AuthContext'

type Props = {
  children: ReactNode
}

export const AuthLayout = (props: Props) => {
  const { children } = props
  const auth = useAuth()

  return (
    <>
      {!auth.hasSession && auth.backgroundElement}
      {children}
    </>
  )
}
